import { Box } from '@chakra-ui/react'

interface SectionHeaderIProps {
  title: string
  subTitle: string
}

export const SectionHeader = ({ title, subTitle }: SectionHeaderIProps) => {
  return (
    <Box mb='20px'>
      <Box fontSize='16px' fontWeight={500}>
        {title}
      </Box>
      <Box fontSize='12px' fontWeight={500}>
        {subTitle}
      </Box>
    </Box>
  )
}
